<template>
  <div id="collateral-info-tab">
    <table>
      <tbody>
        <tr>
          <td>{{ $t('ASSET_CATEGORY') }}</td>
          <td>{{ $t(category.key) }}</td>
        </tr>
        <tr>
          <td>{{ $t('DESCRIPTION') }}</td>
          <td>
            <p>{{ asset.description }}</p>
            <template v-for="key in Object.keys(asset.meta || {})">
              <p v-if="!!asset.meta[key]" :key="key">
                <span class="grey">{{ $t(camelToUpperSnake(key)) }}: </span>
                <span>{{ asset.meta[key] }}</span>
              </p>
            </template>
          </td>
        </tr>
        <tr>
          <td>{{ $t('STATUS') }}</td>
          <td>{{ $t(asset.status) }}</td>
        </tr>
        <tr>
          <td>{{ $t('ORIGIN_CONTRACT') }}</td>
          <td>
            <router-link :to="applyParams(PATHS.CONTRACT_DETAIL, asset.contracts[asset.contracts.length - 1])"> #{{ asset.contracts[asset.contracts.length - 1] }}</router-link>
          </td>
        </tr>
        <tr>
          <td>{{ $t('STORAGE_CODE') }}</td>
          <td>{{ asset.code }}</td>
        </tr>
        <tr>
          <td>{{ $t('STORAGE') }}</td>
          <td>{{ storage.name }}</td>
        </tr>
        <tr>
          <td>{{ $t('EXPECTED_AMOUNT') }}</td>
          <td>{{ addCommas(asset.expectedAmount) }}</td>
        </tr>
        <tr>
          <td>{{ $t('VALUATED_AMOUNT') }}</td>
          <td>{{ addCommas(asset.valuatedAmount) }}</td>
        </tr>
        <tr>
          <td>{{ $t('LIQUIDATION_AMOUNT') }}</td>
          <td></td>
        </tr>
        <tr>
          <td>{{ $t('VALUATOR') }}</td>
          <td>{{ valuator.username ? `${valuator.firstName} ${valuator.lastName} (${valuator.username})` : '' }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { watch, computed } from '@vue/composition-api';
import { createNamespacedHelpers } from 'vuex-composition-helpers';

import { addCommas, camelToUpperSnake, applyParams } from '@/helpers';
import PATHS from '@/consts/paths';

const { useState: useAppState } = createNamespacedHelpers('app');
const { useState, useActions } = createNamespacedHelpers('contractDetail');

export default {
  name: 'CollateralInfoTab',
  setup() {
    const { assetCategories, valuators, storages } = useAppState(['assetCategories', 'valuators', 'storages']);
    const { asset, targetingContract: contract } = useState(['asset', 'targetingContract']);
    const { getAsset } = useActions(['getAsset']);

    const category = computed(() => assetCategories.value.find((c) => c.id === asset.value.categoryId) || {});
    const valuator = computed(() => valuators.value.find((v) => v.id === asset.value.valuatorId) || {});
    const storage = computed(() => storages.value.find((s) => s.id === asset.value.storageId) || {});

    watch(contract, (newDetail) => {
      if (newDetail) {
        getAsset();
      }
    }, {
      immediate: true
    });

    return {
      asset,
      addCommas,
      category,
      valuator,
      storage,
      camelToUpperSnake,
      applyParams,
      PATHS
    };
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/colors";

#collateral-info-tab {
  padding: 12px;

  table {
    width: 100%;
    border-collapse: inherit;
    border-spacing: 0;

    tbody {
      text-align: left;

      tr {
        background-color: $babyPowder;
        transition: all .2s ease-in-out;

        &:hover {
          background-color: $ghostWhite;
        }

        td {
          padding: 10px;
          border-bottom: 2px solid $babyPowder;
          vertical-align: top;

          &:first-child {
            font-weight: bold;
            width: 150px;
          }

          p {
            margin: 0;
            margin-bottom: 5px;

            .grey {
              color: $lavenderGrey;
            }
          }

          a {
            text-decoration: none;
            font-weight: bold;
            color: $paradisePink;
          }
        }
      }
    }
  }
}
</style>
